// extracted by mini-css-extract-plugin
module.exports = {"dividedList":"dividedList__QanzH","dividedList__item":"dividedList__item__254E8"};